import React from "react";

class Sample extends React.Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);
  }

  handleOnClick = (e) => { };

  render() {
    return (
      <>
        <div
          onClick={this.handleOnClick}
          style={{
            marginTop: "10px",
            border: "none",
            // padding: "10px",
            display: "flex",
            flexDirection: "row",
            ":hover": {
              backgroundColor: "#ff0000",
              color: "#ffffff",
            },
          }}
        >
          <div
            // style={{
            //   padding: "10px",
            // }}
          >
            <div style={{ fontWeight: "bold" }}>MINI CAR (On Going)</div>
            <p>
              In this series of topics, I want to build a mini car sytems. This car have feature listed out below.</p>
            <p>
              This car can detect the sound in the air to find moving direction.</p>
            <p>
              It has also the camera system to detect the people in the house. It have ability to answer simples question from Guess.
            </p>
            <p>It have simple question ansering sytem for user can ask</p>
            <div>List of posts that I am creating for this car system:</div>
            <ol style={{ listStyleType: "circle", textIndent: "10px", paddingLeft: "20px", margin: "0.5rem" }}>
              <li>
                <a>
                  Make custom bootloader for Arduino <br />
                </a>
              </li>
              <li>
                <a>Mini Autosar implementation</a></li>
              <li>
                <a>Simple Question Aswering system on car </a>
              </li>
              <li>
                <a>Face recognition on Car</a>
              </li>
            </ol>
            {/* <iframe
              width="420"
              height="315"
              src="https://www.youtube.com/embed/tgbNymZ7vqY"
            /> */}
          </div>
        </div>
        <div
          onClick={this.handleOnClick}
          style={{
            border: "none",
            display: "flex",
            flexDirection: "row",
            marginTop: "20px",
            ":hover": {
              backgroundColor: "#ff0000",
              color: "#ffffff",
            },
          }}
        >
          <div
            // style={{
            //   padding: "10px",
            // }}
          >
            <div style={{ fontWeight: "bold" }}>MINI SOCIAL NETWORK (On Going)</div>
            <p>
              This project intent to build simple social network which is applied machine learning and deep learning algorithm. </p>
            <p>
              The social network is build on using haskell sytem.
            </p>
            <p>Simple features of social network was built suchs as: comment, chat, like,...</p>
            <div>List of posts that I am creating for this social network:</div>
            <ol style={{ listStyleType: "circle", textIndent: "10px", margin: "0.5rem", paddingLeft: "20px" }}>
              <li>
                <a>
                  Hate speech detection <br />
                </a></li>
              <li>
                <a>Face detection</a>
              </li>
              <li>
                <a>Guess Age classifier</a>
              </li>
              <li>
                <a>Build deep learning model on haskell system</a>
              </li>
              <li>
                <a>Fake new warning on social network</a>
              </li>
              <li>
                <a>Naked content warning</a>
              </li>
              <li>
                <a>Recommender system for post content on Social Network</a>
              </li>
            </ol>
          </div>
        </div>
        <div
          onClick={this.handleOnClick}
          style={{
            border: "none",
            display: "flex",
            flexDirection: "row",
            marginTop: "20px",
            ":hover": {
              backgroundColor: "#ff0000",
              color: "#ffffff",
            },
          }}
        >
          <div
          >
            <div style={{ fontWeight: "bold" }}>FIGHTING GAME USING VOICE CONTROL (On Going)</div>
            <p>
              This project atemp to build simple 2D fighting game. Instead of just build control character by hand, this game allow user control by voice</p>
              <p>
                The game can detect noise level and which action from voice, this app enable using many model in speech recognition
              </p>
          </div>
        </div>
      </>
    );
  }
}

export default Sample;
